import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import logoImg from "./assets/LOGO.png";

export default function BouquetDesignerPage() {
  const navigate = useNavigate();

  // Bắt message từ iframe designer
  useEffect(() => {
    const handleMessage = (event) => {
      if (event.data?.source !== "BOUQUET_DESIGNER") return;

      // Thêm vào giỏ hàng
      if (event.data?.type === "ORDER_ACTION") {
        const { price, note, imageDataUrl } = event.data.payload;
        const currentCart = JSON.parse(localStorage.getItem("sellixy_cart")) || [];
        const newBouquet = {
          id:             "design_" + Date.now(),
          name:           "Bó hoa thiết kế riêng" + (note ? ` — ${note}` : ""),
          price:          price > 0 ? price : 270000,
          quantity:       1,
          // Dùng ảnh chụp bó hoa nếu có, fallback về logo
          img:            imageDataUrl || logoImg,
          bouquetPreview: imageDataUrl || null,   // lưu riêng để hiện trong đơn hàng
          isCustom:       true,
        };
        localStorage.setItem("sellixy_cart", JSON.stringify([...currentCart, newBouquet]));
        window.dispatchEvent(new Event("cartUpdated"));
        navigate("/gio-hang-cua-ban");
      }

      // Về trang chủ
      if (event.data?.type === "GO_HOME") {
        navigate("/");
      }
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, [navigate]);

  return (
    // Full-screen — phủ toàn viewport, không có navbar
    <div style={{
      position: "fixed",
      inset: 0,
      zIndex: 9999,
      background: "#fff",
      display: "flex",
      flexDirection: "column",
    }}>
      {/* Nút ← Trang chủ — overlay góc trên trái */}
      <button
        onClick={() => navigate("/")}
        style={{
          position: "absolute",
          top: 14,
          left: 14,
          zIndex: 10000,
          display: "flex",
          alignItems: "center",
          gap: 6,
          background: "rgba(255,255,255,0.93)",
          backdropFilter: "blur(10px)",
          WebkitBackdropFilter: "blur(10px)",
          border: "1px solid rgba(0,0,0,0.1)",
          borderRadius: 10,
          padding: "7px 14px",
          fontSize: 12,
          fontWeight: 600,
          color: "#555",
          cursor: "pointer",
          boxShadow: "0 2px 12px rgba(0,0,0,0.13)",
          fontFamily: '"Montserrat", sans-serif',
          letterSpacing: "0.4px",
          transition: "box-shadow 0.2s, background 0.2s",
        }}
        onMouseEnter={e => {
          e.currentTarget.style.background = "#fff";
          e.currentTarget.style.boxShadow = "0 4px 18px rgba(0,0,0,0.18)";
        }}
        onMouseLeave={e => {
          e.currentTarget.style.background = "rgba(255,255,255,0.93)";
          e.currentTarget.style.boxShadow = "0 2px 12px rgba(0,0,0,0.13)";
        }}
      >
        {/* Arrow left SVG */}
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <path d="M19 12H5M12 5l-7 7 7 7" />
        </svg>
        Trang chủ
      </button>

      {/* iframe full-screen, không viền */}
      <iframe
        title="Thiết kế bó hoa"
        src="/thiet-ke-bo-hoa/index.html"
        style={{ width: "100%", height: "100%", border: "none", display: "block" }}
      />
    </div>
  );
}
